function lastImage(selector) {
    let move_position = 0;
    var card = document.getElementsByClassName('featured-product-image');
    move_position = card[0].offsetWidth + 12;
    var carousel_selected = selector.nextElementSibling.firstElementChild;
    let actual_position = parseInt(carousel_selected.getAttribute("actualPosition"));
    const trackWidth = (carousel_selected.scrollWidth - move_position) * -1;
    if(actual_position >= 0) {
        carousel_selected.style.transform = `translateX(${trackWidth-6}px)`;
        carousel_selected.setAttribute("actualPosition", trackWidth-6); 
    }
    else {
        actual_position += move_position;
        carousel_selected.style.transform = `translateX(${actual_position}px)`;
        carousel_selected.setAttribute("actualPosition", actual_position); 
        selector.nextElementSibling.nextElementSibling.style.visibility = "visible";
    }
}

function nextImage(selector) {
    let move_position = 0;
    var card = document.getElementsByClassName('featured-product-image');
    move_position = card[0].offsetWidth + 12;
    var carousel_selected = selector.previousElementSibling.firstElementChild;
    let actual_position = parseInt(carousel_selected.getAttribute("actualPosition"));
    if (actual_position <= 0) {
        actual_position -= move_position;
        carousel_selected.style.transform = `translateX(${actual_position}px)`;
        carousel_selected.setAttribute("actualPosition", actual_position); 
        selector.previousElementSibling.previousElementSibling.style.visibility = "visible";
        const trackWidth = (carousel_selected.scrollWidth + 6 - move_position) * -1;
        if(actual_position < trackWidth) {
            carousel_selected.style.transform = `translateX(0px)`;
            carousel_selected.setAttribute("actualPosition", 0); 
        }
    }
} 

function buttonDropdown(dropElement) {
    var sibling = dropElement.nextElementSibling;
    if(sibling.classList.contains('active')){
        dropElement.children[1].style.transform = "rotate(360deg)";
        sibling.style.display = "none";
        sibling.classList.remove('active');
        dropElement.classList.remove('active');
    }
    else {
        dropElement.children[1].style.transform = "rotate(180deg)";
        sibling.style.display = "flex";
        sibling.classList.add('active');
        dropElement.classList.add('active');
    }
}